export { SORT_TYPES } from './sortTypes';

export const TAX_WITHHOLDING_COLUMNS = [
  { id: 'event_date', label: 'Event Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'event_name', label: 'Event Name', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'artist_name', label: 'Artist', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'amount', label: 'Amount Withheld', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'withholding_percentage', label: 'Withholding %', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'due_at', label: 'Due Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'paid_at', label: 'Paid Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'payment_method', label: 'Payment Method', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'payment_status', label: 'Status', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
];

export const getDefaultVisibleColumns = () =>
  TAX_WITHHOLDING_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  TAX_WITHHOLDING_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
